import React from "react";
import { connect } from "react-redux";
import BottomNavigation from "../BottomNavigation";
import BottomNavigationItem from "../BottomNavigationItem";
import { Collection, Glasses, Cart, Profile } from "../Icons";
import SupportingText from "../SupportingText";

class MobileNav extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: -1
    };

    this.redLightColorCode = "#EF5753";
    this.redLightestColorCode = "#FCEBEA";
  }

  onChange = index => {
    /* this.setState({
      selectedIndex: index
    }); */
  };

  render() {
    const { selectedIndex } = this.state;
    const { cartCount, isLoggedIn } = this.props;
    return (
      <BottomNavigation selectedIndex={selectedIndex} onChange={this.onChange}>
        <BottomNavigationItem
          href="/filter"
          activeTextColor="red-light"
          icon={isActive => (
            <Collection
              width="28px"
              height="28px"
              stroke={isActive ? `${this.redLightColorCode}` : undefined}
              fill={isActive ? `${this.redLightestColorCode}` : undefined}
            />
          )}
        >
          Filter
        </BottomNavigationItem>
        <BottomNavigationItem
          activeTextColor="red-light"
          href="/article"
          icon={isActive => (
            <div className="pb-1">
              <Glasses
                width="40px"
                height="15px"
                stroke={isActive ? `${this.redLightColorCode}` : undefined}
                fill={isActive ? `${this.redLightestColorCode}` : undefined}
              />
            </div>
          )}
        >
          Artikel
        </BottomNavigationItem>
        <BottomNavigationItem
          href="/cart"
          activeTextColor="red-light"
          icon={isActive => (
            <React.Fragment>
              <div className="relative w-full">
                <Cart
                  width="25px"
                  height="25px"
                  stroke={isActive ? `${this.redLightColorCode}` : undefined}
                  fill={isActive ? `${this.redLightestColorCode}` : undefined}
                />
                <div
                  style={{
                    transform: "translateX(-360%)"
                  }}
                  className="absolute pin-r pin-t"
                >
                  <SupportingText textColor="red-light" inline>
                    {cartCount}
                  </SupportingText>
                </div>
              </div>
            </React.Fragment>
          )}
        >
          Warenkorb
        </BottomNavigationItem>
        <BottomNavigationItem
          activeTextColor="red-light"
          href="/profile"
          icon={isActive => (
            <Profile
              width="25px"
              height="25px"
              stroke={isActive ? `${this.redLightColorCode}` : undefined}
              fill={isActive ? `${this.redLightestColorCode}` : undefined}
            />
          )}
        >
          {isLoggedIn ? "Profil" : "Login"}
        </BottomNavigationItem>
      </BottomNavigation>
    );
  }
}

function ContentBox({ children, cartCount, isLoggedIn }) {
  return (
    <div className="h-full relative overflow-hidden">
      <div className="absolute w-full pin-b pin-l">
        <MobileNav cartCount={cartCount} isLoggedIn={isLoggedIn} />
      </div>
      <div
        style={{
          paddingBottom: "56px"
        }}
        className="w-full h-full overflow-hidden"
      >
        <div className="h-full bg-grey-lighter px-3">
          <div className="h-full relative overflow-hidden">{children}</div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ cart, auth }) => ({
  cartCount: cart.cartItems.length,
  isLoggedIn:
    auth.authStatus.indication === "loaded" && auth.currentUser !== null
});

export default connect(mapStateToProps, null)(ContentBox);



// WEBPACK FOOTER //
// ./src/Layout/MobileContentBox.js